module.exports = __webpack_public_path__ + "media/bootstrap-icons/distribute-vertical-8fc3f02f.svg";